export default "__VITE_ASSET__Dske7wuP__"